(function () {
  'use strict';

  var ROUND_KEYS = [
    'round_of_32',
    'round_of_16',
    'quarter_finals',
    'semi_finals',
    'finals'
  ];

  var ATTR_PICKS = 'Prediction Picks';
  var ATTR_MARKER = 'prediction-game';
  var LEGACY_ATTRS = {
    'Football Prediction': '',
    'Football Prediction Match': ''
  };

  var COPY_DEFAULTS = {
    headerTitle: 'Match Day Pick',
    headerTitleDesktop: 'FIFA MATCH PREDICTION',
    liveLabel: 'Live',
    defaultMessage: 'Predict the winner & win {amount} back in credit!',
    emptyCartMessage: 'Add items to predict & win {percent} credit!',
    selectedMessage: 'Nice pick! Get {amount} back if {team} wins',
    lockedTitle: 'PREDICTION CONFIRMED',
    lockedMessage: 'Nice pick! Get {amount} back if {team} wins',
    editLabel: 'Edit',
    deadlineMessage: 'Predictions for this match close at {deadline}.',
    deadlineClosedMessage: 'Predictions for this match are now closed.'
  };

  var CHECK_SVG =
    '<svg class="wc-widget__btn-check" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M1 5.5L5 9.5L12 1.5" stroke="white" stroke-width="2.5"/>' +
    '</svg>';

  var STRIPE_HTML =
    '<div class="wc-widget__header-stripes" aria-hidden="true">' +
    '<span></span><span></span><span></span><span></span>' +
    '<span></span><span></span><span></span><span></span>' +
    '</div>';

  var PREDICTION_CLOSE_OFFSET_MS = 30 * 60 * 1000;

  var UK_TIME_OPTIONS = {
    timeZone: 'Europe/London',
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short'
  };

  function formatUkTime(date) {
    return date.toLocaleString('en-GB', UK_TIME_OPTIONS);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function teamDisplayName(name) {
    return String(name).toUpperCase();
  }

  function formatPrizeAmount(totalCents, prizePercent) {
    var amount = (totalCents / 100) * (prizePercent / 100);
    var formatted = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(amount);
    return '~' + formatted;
  }

  function getFreebieVariantIds() {
    var ids = [];

    document.querySelectorAll('cart-items').forEach(function (cartItems) {
      if (cartItems.freeProductVariantId) {
        ids.push(String(cartItems.freeProductVariantId));
      }
      if (cartItems.freebie3VariantId) {
        ids.push(String(cartItems.freebie3VariantId));
      }
    });

    return ids;
  }

  function isPrizeEligibleLineItem(item, freebieVariantIds) {
    if (!item) {
      return false;
    }

    if (freebieVariantIds.indexOf(String(item.variant_id)) !== -1) {
      return false;
    }

    var props = item.properties || {};
    if (props._3rd_milestone_popup === 'true') {
      return false;
    }
    if (props._free_product === 'true' || props['_free_product'] === 'true') {
      return false;
    }

    return true;
  }

  function getLineSaleTotalCents(item) {
    if (item.final_line_price != null) {
      return item.final_line_price;
    }
    if (item.line_price != null) {
      return item.line_price;
    }
    if (item.final_price != null && item.quantity != null) {
      return item.final_price * item.quantity;
    }
    if (item.price != null && item.quantity != null) {
      return item.price * item.quantity;
    }
    return 0;
  }

  function getPrizeCartTotalCents(cart, widget) {
    if (cart && Array.isArray(cart.items) && cart.items.length) {
      var freebieVariantIds = getFreebieVariantIds();

      return cart.items.reduce(function (total, item) {
        if (!isPrizeEligibleLineItem(item, freebieVariantIds)) {
          return total;
        }
        return total + getLineSaleTotalCents(item);
      }, 0);
    }

    if (widget && widget.dataset.cartPrizeBase !== undefined && widget.dataset.cartPrizeBase !== '') {
      return parseInt(widget.dataset.cartPrizeBase, 10) || 0;
    }

    return cart && cart.total_price ? cart.total_price : 0;
  }

  function getAssets(widget) {
    return {
      logo: widget.dataset.assetLogo || '',
      trophy: widget.dataset.assetTrophy || '',
      confirmed: widget.dataset.assetConfirmed || '',
      headerPlayers: widget.dataset.assetHeaderPlayers || '',
      headerTrophy: widget.dataset.assetHeaderTrophy || '',
      headerPattern: widget.dataset.assetHeaderPattern || '',
      headerPatternMobile: widget.dataset.assetHeaderPatternMobile || ''
    };
  }

  function getCopy(widget) {
    return {
      headerTitle: widget.dataset.headerTitle || COPY_DEFAULTS.headerTitle,
      headerTitleDesktop: widget.dataset.headerTitleDesktop || COPY_DEFAULTS.headerTitleDesktop,
      liveLabel: widget.dataset.liveLabel || COPY_DEFAULTS.liveLabel,
      defaultMessage: widget.dataset.defaultMessage || COPY_DEFAULTS.defaultMessage,
      emptyCartMessage: widget.dataset.emptyCartMessage || COPY_DEFAULTS.emptyCartMessage,
      selectedMessage: widget.dataset.selectedMessage || COPY_DEFAULTS.selectedMessage,
      lockedTitle: widget.dataset.lockedTitle || COPY_DEFAULTS.lockedTitle,
      lockedMessage: widget.dataset.lockedMessage || COPY_DEFAULTS.lockedMessage,
      editLabel: widget.dataset.editLabel || COPY_DEFAULTS.editLabel,
      deadlineMessage: widget.dataset.deadlineMessage || COPY_DEFAULTS.deadlineMessage,
      deadlineClosedMessage: widget.dataset.deadlineClosedMessage || COPY_DEFAULTS.deadlineClosedMessage
    };
  }

  function formatMessageTemplate(template, prizeAmount, teamName, prizePercent) {
    var amountHtml = '<span class="wc-widget__prize-highlight">' + escapeHtml(prizeAmount) + '</span>';
    var percentHtml = '<span class="wc-widget__prize-highlight">' + escapeHtml(String(prizePercent)) + '%</span>';
    var teamHtml = teamName ? escapeHtml(teamDisplayName(teamName)) : '';
    var parts = String(template).split(/(\{amount\}|\{team\}|\{percent\})/);

    return parts.map(function (part) {
      if (part === '{amount}') {
        return amountHtml;
      }
      if (part === '{percent}') {
        return percentHtml;
      }
      if (part === '{team}') {
        return teamHtml;
      }
      return escapeHtml(part);
    }).join('');
  }

  function formatMatchDeadline(closesAt) {
    return formatUkTime(closesAt);
  }

  function parseMatchKickoff(match) {
    if (!match || !match.kickoff_utc) {
      return null;
    }

    var kickoffAt = new Date(match.kickoff_utc);
    if (Number.isNaN(kickoffAt.getTime())) {
      return null;
    }

    return kickoffAt;
  }

  function getPredictionCloseTime(match) {
    var kickoffAt = parseMatchKickoff(match);
    if (kickoffAt) {
      return new Date(kickoffAt.getTime() - PREDICTION_CLOSE_OFFSET_MS);
    }

    if (!match || !match.closes_at) {
      return null;
    }

    var closesAt = new Date(match.closes_at);
    if (Number.isNaN(closesAt.getTime())) {
      return null;
    }

    return closesAt;
  }

  function isPredictionClosed(config, now) {
    if (!config || !config.closesAt) {
      return false;
    }
    var reference = now || config.now;
    if (!reference) {
      return false;
    }
    return config.closesAt.getTime() <= reference.getTime();
  }

  function formatDeadlineTemplate(template, deadlineFormatted) {
    var deadlineHtml = '<span class="wc-widget__deadline-highlight">' + escapeHtml(deadlineFormatted) + '</span>';
    var parts = String(template).split(/\{deadline\}/);

    return parts.map(function (part, index) {
      return escapeHtml(part) + (index < parts.length - 1 ? deadlineHtml : '');
    }).join('');
  }

  function buildDeadlineNoticeHtml(config, variant) {
    if (!config.closesAt || Number.isNaN(config.closesAt.getTime())) {
      return '';
    }

    var deadlineFormatted = formatMatchDeadline(config.closesAt);
    var isClosed = isPredictionClosed(config, config.now);
    var template = isClosed ? config.copy.deadlineClosedMessage : config.copy.deadlineMessage;
    var classes = ['wc-widget__deadline'];

    if (variant === 'collapsed') {
      classes.push('wc-widget__deadline--collapsed');
    }
    if (isClosed) {
      classes.push('wc-widget__deadline--closed');
    }

    return (
      '<p class="' + classes.join(' ') + '">' +
        formatDeadlineTemplate(template, deadlineFormatted) +
      '</p>'
    );
  }

  function getDefaultFooterTemplate(config) {
    if (config.isCartEmpty) {
      return config.copy.emptyCartMessage;
    }
    return config.copy.defaultMessage;
  }

  function getNow(widget) {
    var testMode = widget.dataset.testMode === 'true';
    if (testMode && widget.dataset.testDatetime) {
      return new Date(widget.dataset.testDatetime);
    }
    return new Date();
  }

  function shakeEmptyCartNotice(mount) {
    if (!mount) {
      return;
    }

    var footer = mount.querySelector('.wc-widget__footer--default');
    if (!footer) {
      return;
    }

    footer.classList.remove('wc-widget__footer--shake');
    void footer.offsetWidth;
    footer.classList.add('wc-widget__footer--shake');

    if (footer._wcShakeTimer) {
      clearTimeout(footer._wcShakeTimer);
    }

    footer._wcShakeTimer = window.setTimeout(function () {
      footer.classList.remove('wc-widget__footer--shake');
      footer._wcShakeTimer = null;
    }, 500);

    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate([12, 30, 12, 30, 12]);
    }
  }

  function normalizeMatchId(match) {
    if (match.match_id) {
      return String(match.match_id).toUpperCase();
    }
    if (match.match_number != null && match.match_number !== '') {
      return 'M' + String(match.match_number).padStart(3, '0');
    }
    return null;
  }

  function normalizeTeamCode(code) {
    if (!code) {
      return null;
    }
    return String(code).toUpperCase().trim();
  }

  function buildPickToken(matchId, teamCode) {
    return 'PICK-' + matchId + '-' + teamCode;
  }

  function parseExistingPicks(picksValue) {
    if (!picksValue || typeof picksValue !== 'string') {
      return [];
    }

    return picksValue.split(',').map(function (token) {
      return token.trim();
    }).filter(Boolean);
  }

  function mergePick(existingPicks, newPickToken) {
    var parts = newPickToken.split('-');
    if (parts.length < 3) {
      return existingPicks.concat([newPickToken]);
    }

    var matchIdPart = parts[1];
    var filtered = existingPicks.filter(function (pick) {
      var pickParts = pick.split('-');
      return pickParts[1] !== matchIdPart;
    });

    filtered.push(newPickToken);
    return filtered;
  }

  function getPreSelectedTeamName(match, existingPicks) {
    var matchId = normalizeMatchId(match);
    if (!matchId) {
      return null;
    }

    var teamACode = normalizeTeamCode(match.team_a_code);
    var teamBCode = normalizeTeamCode(match.team_b_code);
    var prefix = 'PICK-' + matchId + '-';
    var pick = existingPicks.find(function (token) {
      return token.toUpperCase().indexOf(prefix) === 0;
    });

    if (!pick) {
      return null;
    }

    var code = pick.split('-')[2];
    if (!code) {
      return null;
    }

    code = code.toUpperCase();
    if (teamACode && code === teamACode) {
      return match.team_a;
    }
    if (teamBCode && code === teamBCode) {
      return match.team_b;
    }

    return null;
  }

  function parseRoundBlobs(widget) {
    var script = widget.querySelector('script.wc-predict-rounds-data');
    if (!script) {
      return [];
    }

    try {
      var blobs = JSON.parse(script.textContent);
      return Array.isArray(blobs) ? blobs : [];
    } catch (error) {
      console.error('[wc-predict-widget] Failed to parse round JSON:', error);
      return [];
    }
  }

  function collectMatches(roundBlobs) {
    var matches = [];

    roundBlobs.forEach(function (blob) {
      if (!blob) {
        return;
      }

      if (Array.isArray(blob)) {
        matches = matches.concat(blob);
        return;
      }

      if (typeof blob !== 'object') {
        return;
      }

      ROUND_KEYS.forEach(function (key) {
        if (Array.isArray(blob[key])) {
          matches = matches.concat(blob[key]);
        }
      });
    });

    return matches;
  }

  function isMatchOpen(match, now) {
    if (!match || !match.team_a || !match.team_b) {
      return false;
    }

    if (match.status && String(match.status).toUpperCase() === 'FT') {
      return false;
    }

    var closesAt = getPredictionCloseTime(match);
    if (!closesAt) {
      return false;
    }

    return closesAt.getTime() > now.getTime();
  }

  function findUpcomingMatch(matches, now) {
    var openMatches = matches
      .filter(function (match) {
        return isMatchOpen(match, now);
      })
      .sort(function (a, b) {
        return new Date(a.kickoff_utc).getTime() - new Date(b.kickoff_utc).getTime();
      });

    return openMatches[0] || null;
  }

  function buildHeaderSection(assets, copy) {
    var patternDesktopHtml = assets.headerPattern
      ? '<img class="wc-widget__header-pattern wc-widget__header-pattern--desktop" src="' + escapeHtml(assets.headerPattern) + '" alt="" width="308" height="38">'
      : '';
    var patternMobileHtml = assets.headerPatternMobile
      ? '<img class="wc-widget__header-pattern wc-widget__header-pattern--mobile" src="' + escapeHtml(assets.headerPatternMobile) + '" alt="" width="164" height="38">'
      : '';
    var playersHtml = assets.headerPlayers
      ? '<img class="wc-widget__header-players" src="' + escapeHtml(assets.headerPlayers) + '" alt="" width="80" height="100">'
      : '';
    var trophyHtml = assets.headerTrophy
      ? '<span class="wc-widget__header-trophy-wrap">' +
          '<img class="wc-widget__header-trophy" src="' + escapeHtml(assets.headerTrophy) + '" alt="" width="26" height="63">' +
        '</span>'
      : '';

    return (
      '<div class="wc-widget__header-wrap">' +
        '<div class="wc-widget__header">' +
          STRIPE_HTML +
          patternDesktopHtml +
          patternMobileHtml +
          '<div class="wc-widget__header-brand">' +
            (assets.logo ? '<img class="wc-widget__header-logo" src="' + escapeHtml(assets.logo) + '" alt="" width="18" height="18">' : '') +
            '<p class="wc-widget__header-title wc-widget__header-title--mobile">' + escapeHtml(copy.headerTitle) + '</p>' +
            '<p class="wc-widget__header-title wc-widget__header-title--desktop">' + escapeHtml(copy.headerTitleDesktop) + '</p>' +
          '</div>' +
          '<div class="wc-widget__live-pill">' +
            '<span class="wc-widget__live-dot"></span>' +
            '<span class="wc-widget__live-label">' + escapeHtml(copy.liveLabel) + '</span>' +
          '</div>' +
          playersHtml +
          trophyHtml +
        '</div>' +
      '</div>'
    );
  }

  function buildTeamButton(teamName, teamCode, isSelected, isDimmed, isDisabled) {
    var classes = ['wc-widget__btn'];
    if (isSelected) {
      classes.push('wc-widget__btn--selected');
    }
    if (isDimmed) {
      classes.push('wc-widget__btn--dimmed');
    }

    var disabledAttr = isDisabled ? ' disabled' : '';

    return (
      '<button class="' + classes.join(' ') + '" data-team="' + escapeHtml(teamName) + '" data-team-code="' + escapeHtml(teamCode) + '" type="button" aria-pressed="' + (isSelected ? 'true' : 'false') + '"' + disabledAttr + '>' +
        (isSelected ? CHECK_SVG : '') +
        escapeHtml(teamDisplayName(teamName)) +
      '</button>'
    );
  }

  function buildPrizeFooterHtml(assets, mode, config, selectedTeam) {
    var footerClass = mode === 'selected' ? 'wc-widget__footer wc-widget__footer--selected' : 'wc-widget__footer wc-widget__footer--default';
    var template = mode === 'selected' && selectedTeam
      ? config.copy.selectedMessage
      : getDefaultFooterTemplate(config);
    var textHtml = formatMessageTemplate(template, config.prizeAmount, selectedTeam, config.prizePercent);

    var trophyIcon = assets.trophy
      ? '<img class="wc-widget__prize-icon" src="' + escapeHtml(assets.trophy) + '" alt="" width="18" height="18">'
      : '';

    return (
      '<div class="' + footerClass + '">' +
        '<div class="wc-widget__prize">' +
          trophyIcon +
          '<p class="wc-widget__prize-text">' + textHtml + '</p>' +
          trophyIcon +
        '</div>' +
      '</div>'
    );
  }

  function buildExpandedHtml(config, mode, selectedTeam) {
    var assets = config.assets;
    var teamA = config.teamA;
    var teamB = config.teamB;
    var teamACode = config.teamACode;
    var teamBCode = config.teamBCode;
    var hasSelection = mode === 'selected' && selectedTeam;
    var teamASelected = hasSelection && selectedTeam === teamA;
    var teamBSelected = hasSelection && selectedTeam === teamB;
    var isClosed = isPredictionClosed(config, config.now);

    return (
      '<div class="wc-widget__expanded">' +
        buildHeaderSection(assets, config.copy) +
        '<div class="wc-widget__picks" role="group" aria-label="Select predicted winner">' +
          buildTeamButton(teamA, teamACode, teamASelected, hasSelection && !teamASelected, isClosed) +
          '<div class="wc-widget__vs" aria-hidden="true">VS</div>' +
          buildTeamButton(teamB, teamBCode, teamBSelected, hasSelection && !teamBSelected, isClosed) +
        '</div>' +
        '<div class="wc-widget__deadline-wrap">' +
          buildDeadlineNoticeHtml(config) +
        '</div>' +
        buildPrizeFooterHtml(assets, mode, config, selectedTeam) +
      '</div>'
    );
  }

  function buildCollapsedHtml(config, selectedTeam) {
    var assets = config.assets;
    var subHtml = formatMessageTemplate(config.copy.lockedMessage, config.prizeAmount, selectedTeam, config.prizePercent);

    return (
      '<div class="wc-widget__collapsed">' +
        STRIPE_HTML +
        '<div class="wc-widget__collapsed-body">' +
          (assets.logo ? '<img class="wc-widget__header-logo" src="' + escapeHtml(assets.logo) + '" alt="" width="18" height="18">' : '') +
          '<div class="wc-widget__collapsed-text">' +
            '<p class="wc-widget__collapsed-title">' + escapeHtml(config.copy.lockedTitle) + '</p>' +
            '<p class="wc-widget__collapsed-sub">' + subHtml + '</p>' +
            buildDeadlineNoticeHtml(config, 'collapsed') +
          '</div>' +
        '</div>' +
        '<div class="wc-widget__collapsed-actions">' +
          '<button type="button" class="wc-widget__edit-btn">' + escapeHtml(config.copy.editLabel) + '</button>' +
          (assets.confirmed
            ? '<div class="wc-widget__collapsed-badge"><img src="' + escapeHtml(assets.confirmed) + '" alt="" width="28" height="28"></div>'
            : '') +
        '</div>' +
      '</div>'
    );
  }

  function markWidgetReady(widget, isReady) {
    if (isReady) {
      widget.dataset.wcReady = 'true';
    } else {
      delete widget.dataset.wcReady;
    }
  }

  function showWidgetWrapper(widget) {
    var wrapper = widget.closest('#cart-page-predict-widget, #cart-drawer-predict-widget');
    if (wrapper) {
      wrapper.hidden = false;
    }
  }

  function hideWidget(widget) {
    if (widget._wcCloseTimer) {
      clearTimeout(widget._wcCloseTimer);
      widget._wcCloseTimer = null;
    }

    var mount = widget.querySelector('.wc-widget__mount');
    if (mount) {
      mount.innerHTML = '';
      mount.className = 'wc-widget__mount';
    }

    widget.style.display = 'none';
    markWidgetReady(widget, false);
    widget.dataset.wcInitialized = 'false';
    widget._wcCurrentMatch = null;
    widget._wcClickBound = false;
  }

  function resetWidgetInstance(widget) {
    hideWidget(widget);
    widget._wcRenderConfig = null;
    widget._wcPreviousSelection = null;
    widget._wcExistingPicks = [];
  }

  function triggerCartSectionRefresh() {
    document.querySelectorAll('cart-items').forEach(function (cartItems) {
      if (typeof cartItems.refreshCartItems === 'function') {
        cartItems.refreshCartItems();
      }
    });
  }

  function onMatchClosed(widget) {
    resetWidgetInstance(widget);
    triggerCartSectionRefresh();
    window.setTimeout(function () {
      wcPredictInit();
    }, 300);
  }

  function isCartEmpty(cart) {
    return !cart || cart.item_count === 0;
  }

  function hasPredictionSaved(cart) {
    var attrs = (cart && cart.attributes) || {};
    return !!(attrs[ATTR_PICKS] || attrs[ATTR_MARKER]);
  }

  function clearPredictionFromCart(widget) {
    var mount = widget.querySelector('.wc-widget__mount');
    if (mount) {
      mount.classList.add('wc-widget--saving');
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: Object.assign({}, LEGACY_ATTRS, {
          [ATTR_PICKS]: '',
          [ATTR_MARKER]: ''
        })
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart reset failed');
        }
        return response.json();
      })
      .then(function (cart) {
        widget._wcPreviousSelection = null;
        widget._wcExistingPicks = [];

        if (widget._wcRenderConfig) {
          var prizeCartTotal = getPrizeCartTotalCents(cart, widget);
          widget._wcRenderConfig.existingPicks = [];
          widget._wcRenderConfig.prizeAmount = formatPrizeAmount(
            prizeCartTotal,
            widget._wcRenderConfig.prizePercent
          );
          widget._wcRenderConfig.cartTotal = prizeCartTotal;
          widget._wcRenderConfig.isCartEmpty = isCartEmpty(cart);
          widget._wcRenderConfig.itemCount = cart.item_count || 0;
        }

        if (mount) {
          mount.classList.remove('wc-widget--saving');
        }

        return cart;
      })
      .catch(function (error) {
        if (mount) {
          mount.classList.remove('wc-widget--saving');
        }
        throw error;
      });
  }

  function resetSelectionIfCartEmpty(widget, cart) {
    if (!isCartEmpty(cart)) {
      widget._wcLastItemCount = cart.item_count;
      return Promise.resolve(cart);
    }

    var shouldClear = hasPredictionSaved(cart) ||
      widget._wcPreviousSelection ||
      (widget._wcExistingPicks && widget._wcExistingPicks.length);

    widget._wcLastItemCount = 0;

    if (!shouldClear) {
      return Promise.resolve(cart);
    }

    return clearPredictionFromCart(widget);
  }

  function applyWidgetFromCart(widget, config, mount, upcoming, cart) {
    var existingPicks = isCartEmpty(cart)
      ? []
      : parseExistingPicks((cart.attributes || {})[ATTR_PICKS]);
    var preSelected = isCartEmpty(cart)
      ? null
      : getPreSelectedTeamName(upcoming, existingPicks);

    var prizeCartTotal = getPrizeCartTotalCents(cart, widget);
    config.prizeAmount = formatPrizeAmount(prizeCartTotal, config.prizePercent);
    config.cartTotal = prizeCartTotal;
    config.isCartEmpty = isCartEmpty(cart);
    config.itemCount = cart.item_count || 0;
    config.existingPicks = existingPicks;
    widget._wcExistingPicks = existingPicks.slice();
    widget._wcPreviousSelection = preSelected || null;
    widget._wcLastItemCount = cart.item_count;

    showWidgetWrapper(widget);
    markWidgetReady(widget, true);
    widget.style.display = 'block';

    var state = preSelected ? 'locked' : 'default';
    applyWidgetState(mount, state, config, preSelected);
  }
  function refreshWidgetInstance(widget) {
    var config = widget._wcRenderConfig;
    if (!config) {
      initWidgetInstance(widget);
      return;
    }

    var now = getNow(widget);
    var matches = collectMatches(parseRoundBlobs(widget));
    var upcoming = findUpcomingMatch(matches, now);

    if (!upcoming) {
      hideWidget(widget);
      return;
    }

    var matchId = normalizeMatchId(upcoming);
    if (matchId !== config.fixtureId) {
      resetWidgetInstance(widget);
      initWidgetInstance(widget);
      return;
    }

    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to load cart');
        }
        return response.json();
      })
      .then(function (cart) {
        return resetSelectionIfCartEmpty(widget, cart);
      })
      .then(function (cart) {
        var mount = widget.querySelector('.wc-widget__mount');
        if (!mount) {
          return;
        }

        config.now = now;
        applyWidgetFromCart(widget, config, mount, upcoming, cart);
      })
      .catch(function (error) {
        console.error('[wc-predict-widget] Failed to refresh widget:', error);
      });
  }

  function buildTestBannerHtml(config) {
    if (!config.testMode) {
      return '';
    }

    return (
      '<div class="wc-widget__test-banner">' +
        '<span>⚠️ TEST MODE — simulated time: ' + escapeHtml(formatUkTime(config.now)) + '</span>' +
        '<button type="button" class="wc-widget__test-reset">Reset pick</button>' +
      '</div>'
    );
  }

  function updateDeadlineNotice(mount, config) {
    if (!config.closesAt || Number.isNaN(config.closesAt.getTime())) {
      return;
    }

    var isClosed = isPredictionClosed(config, config.now);
    var deadlineFormatted = formatMatchDeadline(config.closesAt);
    var template = isClosed ? config.copy.deadlineClosedMessage : config.copy.deadlineMessage;

    mount.querySelectorAll('.wc-widget__deadline').forEach(function (el) {
      el.innerHTML = formatDeadlineTemplate(template, deadlineFormatted);
      el.classList.toggle('wc-widget__deadline--closed', isClosed);
    });
  }

  function updateTeamButtons(mount, config, selectedTeam) {
    var picks = mount.querySelector('.wc-widget__picks');
    if (!picks) {
      return;
    }

    var hasSelection = !!selectedTeam;
    var isClosed = isPredictionClosed(config, config.now);
    var buttons = picks.querySelectorAll('.wc-widget__btn');

    buttons.forEach(function (btn) {
      var team = btn.dataset.team;
      var isSelected = hasSelection && team === selectedTeam;
      var isDimmed = hasSelection && team !== selectedTeam;

      btn.classList.toggle('wc-widget__btn--selected', isSelected);
      btn.classList.toggle('wc-widget__btn--dimmed', isDimmed);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      btn.disabled = isClosed;

      var check = btn.querySelector('.wc-widget__btn-check');
      if (isSelected && !check) {
        btn.insertAdjacentHTML('afterbegin', CHECK_SVG);
      } else if (!isSelected && check) {
        check.remove();
      }
    });
  }

  function updateFooter(mount, mode, config, selectedTeam) {
    var footer = mount.querySelector('.wc-widget__footer');
    if (!footer) {
      return;
    }

    var isSelected = mode === 'selected';
    footer.classList.toggle('wc-widget__footer--default', !isSelected);
    footer.classList.toggle('wc-widget__footer--selected', isSelected);

    var prizeText = footer.querySelector('.wc-widget__prize-text');
    if (!prizeText) {
      return;
    }

    var template = isSelected && selectedTeam
      ? config.copy.selectedMessage
      : getDefaultFooterTemplate(config);
    prizeText.innerHTML = formatMessageTemplate(template, config.prizeAmount, selectedTeam, config.prizePercent);
  }

  function updateExpandedState(mount, state, config, selectedTeam) {
    mount.className = 'wc-widget__mount wc-widget--' + state;
    updateTeamButtons(mount, config, state === 'selected' ? selectedTeam : null);
    updateDeadlineNotice(mount, config);
    updateFooter(mount, state, config, selectedTeam);
  }

  function handlePredictionClosed(widget) {
    var mount = widget.querySelector('.wc-widget__mount');
    var config = widget._wcRenderConfig;

    if (mount && config) {
      config.now = getNow(widget);
      updateDeadlineNotice(mount, config);
    }

    onMatchClosed(widget);
  }

  function canPatchExpandedState(mount, state) {
    return (state === 'default' || state === 'selected') &&
      mount.querySelector('.wc-widget__card .wc-widget__expanded');
  }

  function applyWidgetState(mount, state, config, selectedTeam) {
    if (canPatchExpandedState(mount, state)) {
      updateExpandedState(mount, state, config, selectedTeam);
      return;
    }

    var testBannerHtml = buildTestBannerHtml(config);

    var cardClass = 'wc-widget__card';
    if (state === 'locked') {
      mount.innerHTML =
        testBannerHtml +
        '<div class="' + cardClass + '">' +
          buildCollapsedHtml(config, selectedTeam) +
        '</div>';
      mount.className = 'wc-widget__mount wc-widget--locked';
    } else {
      mount.innerHTML =
        testBannerHtml +
        '<div class="' + cardClass + '">' +
          buildExpandedHtml(config, state, selectedTeam) +
        '</div>';
      mount.className = 'wc-widget__mount wc-widget--' + state;
    }
  }

  function expandWidgetForEdit(widget) {
    var mount = widget.querySelector('.wc-widget__mount');
    var config = widget._wcRenderConfig;
    if (!mount || !config) {
      return;
    }

    config.now = getNow(widget);
    if (isPredictionClosed(config, config.now)) {
      handlePredictionClosed(widget);
      return;
    }

    var previousSelection = widget._wcPreviousSelection || null;
    applyWidgetState(
      mount,
      previousSelection ? 'selected' : 'default',
      config,
      previousSelection
    );
  }

  function resetPrediction(widget) {
    clearPredictionFromCart(widget)
      .then(function () {
        widget.dataset.wcInitialized = 'false';
        widget._wcCurrentMatch = null;
        initWidgetInstance(widget);
      })
      .catch(function (error) {
        console.error('[wc-predict-widget] Failed to reset prediction:', error);
      });
  }

  function bindClickHandler(widget) {
    if (widget._wcClickBound) {
      return;
    }

    widget._wcClickBound = true;
    widget.addEventListener('click', function (event) {
      if (event.target.closest('.wc-widget__test-reset')) {
        if (widget.dataset.testMode === 'true') {
          resetPrediction(widget);
        }
        return;
      }

      if (event.target.closest('.wc-widget__edit-btn')) {
        expandWidgetForEdit(widget);
        return;
      }

      var btn = event.target.closest('.wc-widget__btn');
      if (!btn || !widget.contains(btn)) {
        return;
      }

      var current = widget._wcCurrentMatch;
      if (!current) {
        return;
      }

      handleTeamSelect(widget, btn, current);
    });
  }

  function initWidgetInstance(widget) {
    if (widget.dataset.wcInitialized === 'true') {
      return;
    }

    var now = getNow(widget);
    var roundBlobs = parseRoundBlobs(widget);
    var matches = collectMatches(roundBlobs);
    var upcoming = findUpcomingMatch(matches, now);

    if (!upcoming) {
      return;
    }

    var teamA = upcoming.team_a;
    var teamB = upcoming.team_b;
    var matchId = normalizeMatchId(upcoming);
    var teamACode = normalizeTeamCode(upcoming.team_a_code);
    var teamBCode = normalizeTeamCode(upcoming.team_b_code);
    var kickoffAt = parseMatchKickoff(upcoming);
    var closesAt = getPredictionCloseTime(upcoming);
    var prizePercent = parseFloat(widget.dataset.prize || '15') || 15;

    if (!matchId || !teamACode || !teamBCode) {
      console.error('[wc-predict-widget] Match missing match_id/match_number or team_a_code/team_b_code');
      return;
    }

    if (!kickoffAt || !closesAt) {
      return;
    }

    widget.dataset.wcInitialized = 'true';

    var testMode = widget.dataset.testMode === 'true';

    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to load cart');
        }
        return response.json();
      })
      .then(function (cart) {
        return resetSelectionIfCartEmpty(widget, cart);
      })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var existingPicks = isCartEmpty(cart) ? [] : parseExistingPicks(attrs[ATTR_PICKS]);
        var preSelected = isCartEmpty(cart) ? null : getPreSelectedTeamName(upcoming, existingPicks);
        var prizeCartTotal = getPrizeCartTotalCents(cart, widget);
        var renderConfig = {
          teamA: teamA,
          teamB: teamB,
          teamACode: teamACode,
          teamBCode: teamBCode,
          fixtureId: matchId,
          matchNumber: upcoming.match_number,
          prizeAmount: formatPrizeAmount(prizeCartTotal, prizePercent),
          prizePercent: prizePercent,
          cartTotal: prizeCartTotal,
          itemCount: cart.item_count,
          isCartEmpty: isCartEmpty(cart),
          existingPicks: existingPicks,
          testMode: testMode,
          now: now,
          closesAt: closesAt,
          kickoffAt: kickoffAt,
          assets: getAssets(widget),
          copy: getCopy(widget)
        };

        renderWidget(widget, renderConfig, preSelected);
      })
      .catch(function (error) {
        console.error('[wc-predict-widget] Failed to load cart:', error);
        widget.dataset.wcInitialized = 'false';
      });
  }

  function renderWidget(widget, config, preSelected) {
    var mount = widget.querySelector('.wc-widget__mount');
    if (!mount) {
      return;
    }

    widget._wcRenderConfig = config;
    widget._wcCurrentMatch = {
      team_a: config.teamA,
      team_b: config.teamB,
      team_a_code: config.teamACode,
      team_b_code: config.teamBCode,
      fixture_id: config.fixtureId,
      match_number: config.matchNumber
    };
    widget._wcExistingPicks = config.existingPicks.slice();
    widget._wcPreviousSelection = preSelected || null;
    widget._wcLastItemCount = config.itemCount || 0;

    var state = preSelected ? 'locked' : 'default';
    applyWidgetState(mount, state, config, preSelected);

    showWidgetWrapper(widget);
    markWidgetReady(widget, true);
    widget.style.display = 'block';
    bindClickHandler(widget);
    scheduleAutoClose(widget, config);
  }

  function scheduleAutoClose(widget, config) {
    if (widget._wcCloseTimer) {
      clearTimeout(widget._wcCloseTimer);
    }

    var msUntilClose = config.closesAt.getTime() - config.now.getTime();
    if (msUntilClose > 0 && msUntilClose < 24 * 60 * 60 * 1000) {
      widget._wcCloseTimer = setTimeout(function () {
        onMatchClosed(widget);
      }, msUntilClose);
    }
  }

  function handleTeamSelect(widget, clickedBtn, match) {
    var mount = widget.querySelector('.wc-widget__mount');
    var config = widget._wcRenderConfig;
    if (!mount || !config) {
      return;
    }

    var selectedTeam = clickedBtn.dataset.team;
    var selectedCode = normalizeTeamCode(clickedBtn.dataset.teamCode);
    var previousSelection = widget._wcPreviousSelection || null;
    var fixtureId = match.fixture_id;

    if (!selectedCode || !fixtureId) {
      return;
    }

    if (widget._wcLastItemCount === 0 || config.isCartEmpty) {
      shakeEmptyCartNotice(mount);
      return;
    }

    config.now = getNow(widget);
    if (isPredictionClosed(config, config.now)) {
      handlePredictionClosed(widget);
      return;
    }

    if (previousSelection === selectedTeam) {
      return;
    }

    applyWidgetState(mount, 'selected', config, selectedTeam);
    mount.classList.add('wc-widget--saving');

    var newPickToken = buildPickToken(fixtureId, selectedCode);
    var updatedPicks = mergePick(widget._wcExistingPicks || [], newPickToken);
    var picksValue = updatedPicks.join(',');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: Object.assign({}, LEGACY_ATTRS, {
          [ATTR_PICKS]: picksValue,
          [ATTR_MARKER]: 'true'
        })
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart update failed');
        }
        return response.json();
      })
      .then(function (cart) {
        widget._wcPreviousSelection = selectedTeam;
        widget._wcExistingPicks = updatedPicks;
        var prizeCartTotal = getPrizeCartTotalCents(cart, widget);
        config.prizeAmount = formatPrizeAmount(prizeCartTotal, config.prizePercent);
        config.cartTotal = prizeCartTotal;
        config.isCartEmpty = isCartEmpty(cart);
        config.itemCount = cart.item_count || 0;
        mount.classList.remove('wc-widget--saving');
        applyWidgetState(mount, 'locked', config, selectedTeam);
      })
      .catch(function (error) {
        console.error('[wc-predict-widget] Failed to save prediction:', error);
        mount.classList.remove('wc-widget--saving');
        applyWidgetState(
          mount,
          previousSelection ? 'locked' : 'default',
          config,
          previousSelection
        );
      });
  }

  function wcPredictInit() {
    requestAnimationFrame(function () {
      document.querySelectorAll('#wc-predict-widget').forEach(function (widget) {
        var mount = widget.querySelector('.wc-widget__mount');
        if (!mount || !mount.innerHTML) {
          widget.dataset.wcInitialized = 'false';
          widget._wcClickBound = false;
          initWidgetInstance(widget);
        } else if (widget.dataset.wcInitialized === 'true') {
          refreshWidgetInstance(widget);
        } else {
          initWidgetInstance(widget);
        }
      });
    });
  }

  window.wcPredictInit = wcPredictInit;

  var INIT_EVENTS = [
    'DOMContentLoaded',
    'cart:refresh',
    'sections:rendered',
    'cart-drawer:open',
    'dispatch:cart-drawer:refresh',
    'on:cart:change',
    'on:cart-drawer:after-open'
  ];

  if (window.__wcPredictBound) {
    wcPredictInit();
    return;
  }

  window.__wcPredictBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wcPredictInit);
  } else {
    wcPredictInit();
  }

  INIT_EVENTS.slice(1).forEach(function (eventName) {
    document.addEventListener(eventName, wcPredictInit);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      wcPredictInit();
    }
  });
})();
